// Types de plateforme (utilisé pour analytics, device info, etc.)
export enum PlatformType {
  Mobile = 'Mobile',
  Booth = 'Booth',
  Desktop = 'Desktop',
  Web = 'Web',
  Dedicated = 'Dedicated',
}
